import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 120, suffix: "+", label: "Automations delivered" },
  { value: 40, suffix: "+", label: "Clients worldwide" },
  { value: 3.2, suffix: "x", label: "Average ROI in year one", decimals: 1 },
  { value: 24, suffix: "/7", label: "Autonomous uptime" },
];

const Counter = ({ value, suffix, decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {display.toFixed(decimals)}
      <span className="gradient-text">{suffix}</span>
    </span>
  );
};

export const Stats = () => {
  return (
    <section id="results" className="relative py-28 lg:py-32 px-6" data-testid="stats-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="text-center lg:text-left border-l-0 lg:border-l border-[#00F2FE]/15 lg:pl-8"
            >
              <div className="font-['Outfit'] font-light text-5xl lg:text-6xl tracking-tight text-[#E8F1F5]">
                <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
              </div>
              <p className="mt-4 text-sm text-[#8AA1B1] tracking-wide">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
